import { all, put, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { doAppleSignIn, doAppleSignInFail } from './AppleSignInActions'
import { push } from 'connected-react-router'
import { getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { isNative } from '../../../common/helpers/isNative'
import { dataSync } from '../../../services/DataSync'

function* sagaAppleSignIn() {
  document.body.classList.add('logging-in')

  // Wait for getWhoAmI to finish.
  yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

  // Make sure Apple Health is synced on login.
  if (isNative()) {
    setTimeout(() => {
      dataSync(true).then()
    }, 1000)
  }

  // ?
  yield put(push('/register-user'))

  document.body.classList.remove('logging-in')
}

function* sagaAppleSignInFail({ payload }: any) {
  yield put({ type: String(clearNotification) })

  const msg = payload && payload.signInWithAppleMsg ? payload.signInWithAppleMsg : payload
  let signupErrorNotification: INotification
  if (msg === 'invalidCompanyCode') {
    signupErrorNotification = {
      type: 'warning',
      content: t`Sorry, the sign up code provided is not valid`,
    }
  } else if (msg === 'notRegistered') {
    signupErrorNotification = {
      type: 'warning',
      content: t`Sorry, we did not find a related YuMuuv account to your Apple ID. Please sign up first or contact support@yumuuv.com`,
    }
  } else if (msg === 'disallowedDomain') {
    signupErrorNotification = {
      type: 'warning',
      content: t`Sorry, the sign up code provided does not allow signing up with the specified email address. Please sign up using another email address or contact your employer.`,
    }
  } else if (msg === 'disallowedRegion') {
    signupErrorNotification = {
      type: 'warning',
      content: t`Sorry, the given sign up code does not allow signing up from your region.`,
    }
  } else if (msg === 'userLimitExceeded') {
    signupErrorNotification = {
      type: 'warning',
      content: t`Sorry, this community has exceeded it's user limit. Please contact your challenge organizer for more info.`,
    }
  } else {
    signupErrorNotification = {
      type: 'warning',
      content: t`There was a problem with your Apple account. Please try again or try signing up using sign up code and email or contact our support support@yumuuv.com`,
    }
  }
  yield put({ type: String(addNotification), payload: signupErrorNotification })
}

export function* appleSignInSagas() {
  yield all([
    takeEvery(String(doAppleSignIn), sagaAppleSignIn),
    takeEvery(String(doAppleSignInFail), sagaAppleSignInFail),
  ])
}
